module.exports = __webpack_public_path__ + "static/img/win-1.042d802.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/win/win-1.jpg
// module id = 257
// module chunks = 6